import { Tooltip } from "@onengine/component-library";
import type { ComponentType, ReactNode } from "react";

type WithConditionalTooltipProps = {
  showTooltip: boolean;
  tooltipLabel: string;
  onClick?: () => void;
  children?: ReactNode;
};

function withConditionalTooltip<P extends object>(WrappedComponent: ComponentType<P>) {
  const ComponentWithToolTip = ({
    showTooltip,
    tooltipLabel,
    children,
    ...props
  }: WithConditionalTooltipProps & P) =>
    showTooltip ? (
      <Tooltip
        content={<span style={{ overflowWrap: "anywhere" }}>{tooltipLabel}</span>}
        pointer="top-center"
      >
        <div style={{ width: "fit-content" }} data-testid="wrapper-div">
          <WrappedComponent {...(props as P)}>{children}</WrappedComponent>
        </div>
      </Tooltip>
    ) : (
      <WrappedComponent {...(props as P)}>{children}</WrappedComponent>
    );

  ComponentWithToolTip.displayName = `withConditionalTooltip(${
    WrappedComponent.displayName ?? WrappedComponent.name
  })`;

  return ComponentWithToolTip;
}

export default withConditionalTooltip;
